import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IUniteOrganisationnelle, ICreateUniteOrganisationnelleRequest, IUpdateUniteOrganisationnelleRequest } from 'src/app/shared/models/up-evaluation';

@Injectable({ providedIn: 'root' })
export class UniteOrganisationnelleService {

  private readonly apiUrl = '/api/v1/referentiel/unites-organisationnelles';

  constructor(private http: HttpClient) {}

  getAll(): Observable<IUniteOrganisationnelle[]> {
    return this.http.get<IUniteOrganisationnelle[]>(this.apiUrl);
  }

  create(request: ICreateUniteOrganisationnelleRequest): Observable<IUniteOrganisationnelle> {
    return this.http.post<IUniteOrganisationnelle>(this.apiUrl, request);
  }

  update(id: string, request: IUpdateUniteOrganisationnelleRequest): Observable<IUniteOrganisationnelle> {
    return this.http.patch<IUniteOrganisationnelle>(`${this.apiUrl}/${id}`, request);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  exportData(): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/export`, { responseType: 'blob' });
  }
}